import { OuvidoriaProvider } from '@/modules/ouvidoria'
import Page from '@/modules/ouvidoria/pages/index.page'

Page.FlowProvider = OuvidoriaProvider

export default Page
